import * as React from 'react';
const SvgImageStack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M18.5 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.998 6.002c0-1.16-.05-1.831-.32-2.361-.29-.56-.75-1.02-1.31-1.31C15.726 2 14.885 2 13.205 2H6.802c-1.68 0-2.52 0-3.161.33-.56.29-1.02.75-1.31 1.31C2 4.282 2 5.123 2 6.803v6.404c0 1.68 0 2.52.33 3.161.29.56.75 1.02 1.31 1.31.531.271 1.201.321 2.362.321.008 1.166.055 1.832.328 2.362.29.56.75 1.02 1.31 1.31.64.33 1.48.33 3.16.33h6.4c1.68 0 2.52 0 3.16-.33.56-.29 1.02-.75 1.31-1.31.33-.64.33-1.48.33-3.16v-6.4c0-1.68 0-2.52-.33-3.16-.29-.56-.75-1.02-1.31-1.31-.53-.273-1.196-.32-2.362-.328M15.997 6l-.01-.008c-.01-.7-.03-1.29-.11-1.45-.1-.19-.25-.34-.44-.44-.21-.111-1.25-.111-2.251-.111H6.782c-1 0-2.04 0-2.25.11-.19.1-.34.25-.44.44-.111.21-.111 1.25-.111 2.251v6.404c0 1 0 2.04.11 2.25.1.19.25.34.44.44.15.081.75.111 1.451.111l.018.02V10.8c0-1.68 0-2.52.33-3.16.29-.56.75-1.02 1.31-1.31C8.28 6 9.12 6 10.8 6zM20 18v-.8h.02v-6.4c0-1 0-2.04-.11-2.25-.1-.19-.25-.34-.44-.44C19.26 8 18.22 8 17.22 8h-6.4c-1 0-2.04 0-2.25.11-.19.1-.34.25-.44.44-.11.21-.11 1.25-.11 2.25V18l3.29-3.29a.996.996 0 0 1 1.41 0L16.01 18l1.29-1.29a.996.996 0 0 1 1.41 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgImageStack;
